import { Injectable } from '@angular/core';
import { HelpersService } from './helpers';
import * as Highcharts from 'highcharts';
import { round } from 'lodash';

export const TargetPercentage = 90;

@Injectable({
  providedIn: 'root'
})
export class WindowWalkService {
  constructor(private helperService: HelpersService) {}
  //eslint-disable-next-line
  getDeviceType() {
    let currentDevice = 'PC';
    const ua = navigator.userAgent;
    const deviceWidth = window.screen.width;
    const isIpad = ua.includes('Macintosh') && 'ontouchend' in document;

    /** Tablet */
    if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || isIpad) {
      currentDevice = 'Mobile';
    }

    /** Mobile */
    if (/Mobi|Android|iPhone|BlackBerr|IEMobile|Opera Mini/i.test(ua)) {
      currentDevice = 'Mobile';
    }

    if (deviceWidth <= 1024) {
      currentDevice = 'Mobile';
    }
    return currentDevice;
  }

  //eslint-disable-next-line
  parseConfiguration(data) {
    const configuration = {};

    if (data.config) {
      const config = this.getTestOptions(
        'truespeed',
        ['truespeed', 'hide-client-results'],
        data.config
      );
      if (config && config['truespeed']) {
        const testOptions = JSON.parse(config['truespeed'])['truespeed:truespeed'];
        if (testOptions) {
          if (testOptions['truespeed-parameters']) {
            const parms = testOptions['truespeed-parameters'];
            for (const x in parms) {
              switch (x) {
                case 'engine-b-to-a-cir':
                  configuration['upstreamCir'] = parseFloat(parms[x]);
                  break;
                case 'engine-a-to-b-cir':
                  configuration['downstreamCir'] = parseFloat(parms[x]);
                  break;
                case 'threshold-unit-mbps':
                  configuration['thresholdUnitMbps'] = parms[x] === 'true';
                  break;
                case 'engine-b-to-a-threshold':
                  configuration['threshold'] = parseFloat(parms[x]);
                  break;
                case 'engine-a-to-b-threshold':
                  configuration['thresholdDownstream'] = parseFloat(parms[x]);
                  break;
                case 'num-windows':
                  configuration['numWindow'] = parseInt(parms[x]);
                  break;
                case 'connections':
                  configuration['connections'] = parseInt(parms[x]);
                  break;
                case 'run-saturation-window':
                  //Force to string, because MTS is sending string
                  configuration['runSaturationWindow'] = parms[x].toString();
                  break;
                case 'dynamic-saturation':
                  configuration['dynamicSaturation'] = parms[x].toString();
                  break;
                case 'window-duration':
                  configuration['windowDuration'] = parms[x] === 0 ? 15 : parms[x];
                  break;
                case 'percent-start-window-walk':
                  configuration['percentStartWindowWalk'] = parms[x];
                  break;
                case 'tos-dscp':
                  configuration['serviceType'] = parms[x];
                  if (configuration['serviceType'].type === 'tos') {
                    this.formatTos(configuration);
                  } else {
                    configuration['serviceType'].dscp = this.helperService.formatDiffValue(
                      configuration['serviceType'].dscp
                    );
                  }

                  break;
                case 'tcp-port':
                  if (parseInt(parms[x]) === 0) {
                    configuration['tcpPort'] = 'AUTO';
                  } else {
                    configuration['tcpPort'] = parseInt(parms[x]);
                  }
                  break;
                case 'percent-over-saturate-window':
                  configuration['percentOverSaturateWindow'] = parseInt(parms[x]);
                  break;
                case 'percent-over-saturate-connections':
                  configuration['percentOverSaturateConnections'] = parseInt(parms[x]);
                  break;
                case 'destination-ip':
                  configuration['jmepIpAddress'] = parms[x];
                  break;
                default:
                  break;
              }
            }
          }

          configuration['engineA'] = testOptions['engine-a-info'];
          configuration['engineB'] = testOptions['engine-b-info'];
        }
      }

      if (config && config['hide-client-results']) {
        configuration['hideClientResults'] = config['hide-client-results'];
      }
    }

    return configuration;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  parseUDPConfiguration(data) {
    const configuration = {};

    if (data.config) {
      const config = this.getTestOptions('udp', ['udp', 'hide-client-results'], data.config);
      if (config && config['udp']) {
        const testOptions = JSON.parse(config['udp'])['udp:udp'];
        if (testOptions) {
          if (testOptions['udp-parameters']) {
            const parms = testOptions['udp-parameters'];
            for (const x in parms) {
              switch (x) {
                case 'engine-b-to-a-cir':
                  configuration['upstreamCir'] = parseFloat(parms[x]);
                  break;
                case 'engine-a-to-b-cir':
                  configuration['downstreamCir'] = parseFloat(parms[x]);
                  break;
                case 'num-windows':
                  configuration['numWindow'] = parseInt(parms[x]);
                  break;
                case 'connections':
                  configuration['connections'] = parseInt(parms[x]);
                  break;
                case 'run-saturation-window':
                  //Force to string, because MTS is sending string
                  configuration['runSaturationWindow'] = parms[x].toString();
                  break;
                case 'dynamic-saturation':
                  configuration['dynamicSaturation'] = parms[x].toString();
                  break;
                case 'window-duration':
                  configuration['windowDuration'] = parms[x] === 0 ? 15 : parms[x];
                  break;
                case 'percent-start-window-walk':
                  configuration['percentStartWindowWalk'] = parms[x];
                  break;
                case 'tos-dscp':
                  configuration['serviceType'] = parms[x];
                  if (configuration['serviceType'].type === 'tos') {
                    this.formatTos(configuration);
                  } else {
                    configuration['serviceType'].dscp = this.helperService.formatDiffValue(
                      configuration['serviceType'].dscp
                    );
                  }

                  break;
                case 'tcp-port':
                  if (parseInt(parms[x]) === 0) {
                    configuration['tcpPort'] = 'AUTO';
                  } else {
                    configuration['tcpPort'] = parseInt(parms[x]);
                  }
                  break;
                case 'percent-over-saturate-window':
                  configuration['percentOverSaturateWindow'] = parseInt(parms[x]);
                  break;
                case 'percent-over-saturate-connections':
                  configuration['percentOverSaturateConnections'] = parseInt(parms[x]);
                  break;
                case 'destination-ip':
                  configuration['jmepIpAddress'] = parms[x];
                  break;
                default:
                  break;
              }
            }
          }

          configuration['engineA'] = testOptions['engine-a-info'];
          configuration['engineB'] = testOptions['engine-b-info'];
        }
      }

      if (config && config['hide-client-results']) {
        configuration['hideClientResults'] = config['hide-client-results'];
      }
    }

    return configuration;
  }
  //eslint-disable-next-line
  getTestOptions(taskName, optArray, config) {
    const returnObj = {};
    const primaryAgentInfo = this.getAgentInfo('primary', config);
    if (primaryAgentInfo) {
      const primaryConfig = this.getMATestConfigByName(config, primaryAgentInfo.config);
      if (primaryConfig) {
        const testSchedule = this.extractScheduleByTaskName(primaryConfig, taskName);
        if (testSchedule) {
          for (let x = 0, xlen = optArray.length; x < xlen; ++x) {
            const testOption = this.extractScheduleOptionByName(testSchedule, optArray[x]);
            if (testOption) {
              returnObj[optArray[x]] = testOption;
            }
          }
        }
      }
    }
    return returnObj;
  }
  //eslint-disable-next-line
  getAgentInfo(agentType, controllerConfig) {
    if (agentType && controllerConfig && controllerConfig.agent) {
      if (agentType === 'primary') {
        if (controllerConfig.agent.primary) {
          return controllerConfig.agent.primary;
        }
      } else if (agentType === 'secondary') {
        if (controllerConfig.agent.secondary) {
          return controllerConfig.agent.secondary;
        }
      }
    }
    return null;
  }
  //eslint-disable-next-line
  getMATestConfigByName(controllerConfig, configName) {
    if (
      configName &&
      controllerConfig.config &&
      controllerConfig.config.length &&
      controllerConfig.config.length > 0
    ) {
      for (const x in controllerConfig.config) {
        for (const y in controllerConfig.config[x]) {
          if (y === configName) {
            return controllerConfig.config[x][y];
          }
        }
      }
    }
    return null;
  }

  //eslint-disable-next-line
  extractScheduleByTaskName(lmapObj, taskName) {
    if (
      lmapObj['ietf-lmap-control:lmap'] &&
      lmapObj['ietf-lmap-control:lmap'].schedules &&
      lmapObj['ietf-lmap-control:lmap'].schedules.schedule
    ) {
      for (const x in lmapObj['ietf-lmap-control:lmap'].schedules.schedule) {
        if (lmapObj['ietf-lmap-control:lmap'].schedules.schedule[x].action) {
          for (const y in lmapObj['ietf-lmap-control:lmap'].schedules.schedule[x].action) {
            if (
              lmapObj['ietf-lmap-control:lmap'].schedules.schedule[x].action[y].task === taskName
            ) {
              return lmapObj['ietf-lmap-control:lmap'].schedules.schedule[x];
            }
          }
        }
      }
    }
    return null;
  }
  //eslint-disable-next-line
  extractScheduleOptionByName(schedObj, optionId) {
    if (schedObj && schedObj.action) {
      for (const x in schedObj.action) {
        if (schedObj.action[x].option) {
          for (const y in schedObj.action[x].option) {
            if (schedObj.action[x].option[y].id === optionId) {
              return schedObj.action[x].option[y].value;
            }
          }
        }
      }
    }
    return null;
  }
  //eslint-disable-next-line
  formatTos(configuration) {
    configuration.serviceType.showTos = configuration.serviceType.tos.toString(2);
    while (configuration.serviceType.showTos.length < 8) {
      configuration.serviceType.showTos = '0' + configuration.serviceType.showTos;
    }
  }

  getTargetValue(rateUnderTest: string): number {
    if (rateUnderTest) {
      return round(parseFloat(rateUnderTest), 1);
    }
    return 0;
  }

  getPassFailValue(rateUnderTest: string, threshold = TargetPercentage): number {
    if (rateUnderTest) {
      return round((parseFloat(rateUnderTest) / 100) * threshold, 1);
    }
    return 0;
  }

  //eslint-disable-next-line
  getWindowResults(result, configuration) {
    let windowResults = {};
    const upstreamIdeal = [];
    const upstreamAvg = [];
    const upstreamWindow = [];
    const downstreamIdeal = [];
    const downstreamAvg = [];
    const downstreamWindow = [];
    let windowResultsReceived = 0;

    const table = result['ietf-lmap-report:report'].result[0].table[0];
    const testTypeIndex = table.column.indexOf('truespeed-type');
    const originatorIndex = table.column.indexOf('originator');
    const rateUnderTestIndex = table.column.indexOf('rate-under-test');
    const avgThruIndex = table.column.indexOf('avg-thruput');
    const windowIdIndex = table.column.indexOf('window-id');
    const windowSizeIndex = table.column.indexOf('window-size');
    const connectionIndex = table.column.indexOf('connections');
    const dynamicSatWindowIndex = table.column.indexOf('dynamic-saturation-total-window-size');
    const dynamicSatConnectionIndex = table.column.indexOf('dynamic-saturation-total-connections');
    const mssIndex = table.column.indexOf('mss');
    const mtuIndex = table.column.indexOf('mtu');
    const rttIndex = table.column.indexOf('baseline-rtt');
    const rttBaseIndex = table.column.indexOf('baseline-rtt');
    const engAIpIndex = table.column.indexOf('engine-a-ip');
    const engBPubIPIndex = table.column.indexOf('engine-b-public-ip');
    const engBPriIPIndex = table.column.indexOf('engine-b-private-ip');
    const tcpPortIndex = table.column.indexOf('tcp-port');

    //Initialize window
    for (let i = 1; i <= configuration.numWindow; i++) {
      upstreamWindow.push('Window ' + i);
      upstreamIdeal.push(0);
      upstreamAvg.push(0);

      downstreamWindow.push('Window ' + i);
      downstreamIdeal.push(0);
      downstreamAvg.push(0);
    }

    if (configuration.runSaturationWindow === 'true') {
      upstreamWindow.push(
        configuration.dynamicSaturation === 'true'
          ? 'Dynamic Saturation Window'
          : 'Saturation Window'
      );
      upstreamIdeal.push(0);
      upstreamAvg.push(0);

      downstreamWindow.push(
        configuration.dynamicSaturation === 'true'
          ? 'Dynamic Saturation Window'
          : 'Saturation Window'
      );
      downstreamIdeal.push(0);
      downstreamAvg.push(0);
    }

    //Populate upstream/downstream thruput
    const values = table.row;
    windowResultsReceived = values.length;
    let isThinClientTest = false;
    for (let i = 0; i < values.length; i++) {
      if (values[i].value[windowIdIndex] !== '') {
        isThinClientTest = values[i].value[testTypeIndex] === 'thin-engine';
        const originator = values[i].value[originatorIndex];
        let windowId = parseInt(values[i].value[windowIdIndex]);
        let idealValue = this.getTargetValue(values[i].value[rateUnderTestIndex]);
        let avgValue = 0;
        if (values[i].value[avgThruIndex] !== '') {
          avgValue = parseFloat(values[i].value[avgThruIndex]);
        } else {
          windowResultsReceived--;
        }

        let ideal = upstreamIdeal;
        let avg = upstreamAvg;
        let window = upstreamWindow;

        if (originator === 'engine-a') {
          ideal = downstreamIdeal;
          avg = downstreamAvg;
          window = downstreamWindow;

          idealValue = idealValue * -1;
          avgValue = avgValue * -1;

          windowId = windowId - configuration.numWindow;
          if (configuration.runSaturationWindow === 'true') {
            windowId = windowId - 1;
          }
        }

        let windowSize = Number(values[i].value[windowSizeIndex]) || 0;
        if (values[i].value[dynamicSatWindowIndex]) {
          windowSize = Number(values[i].value[dynamicSatWindowIndex]) || 0;
        }
        let connection = Number(values[i].value[connectionIndex]) || 0;
        if (values[i].value[dynamicSatConnectionIndex]) {
          connection = Number(values[i].value[dynamicSatConnectionIndex]) || 0;
        }
        let isSaturationWindow = false;
        if (
          configuration.runSaturationWindow === 'true' &&
          (i === configuration.numWindow || i === configuration.numWindow * 2 + 1)
        ) {
          isSaturationWindow = true;
        }

        const aggregateWindowString = this.getWindowLabel(
          windowSize,
          connection,
          isSaturationWindow,
          isSaturationWindow && configuration.dynamicSaturation === 'true'
        );
        if (isThinClientTest) {
          windowId = 0;
        }
        window[windowId] = aggregateWindowString;
        ideal[windowId] = idealValue;
        avg[windowId] = avgValue;
      }
    }

    windowResults = {
      upstream: {
        window: upstreamWindow,
        ideal: upstreamIdeal,
        avg: upstreamAvg
      },

      downstream: {
        window: downstreamWindow,
        ideal: downstreamIdeal,
        avg: downstreamAvg
      },

      mss: values[values.length - 1].value[mssIndex],
      rtt: parseFloat(values[values.length - 1].value[rttIndex]).toFixed(2),
      rttBase: values[values.length - 1].value[rttBaseIndex],
      mtu: values[values.length - 1].value[mtuIndex],
      engAIPAddr: engAIpIndex !== -1 ? values[values.length - 1].value[engAIpIndex] : '',
      engBPublicIPAddr:
        engBPubIPIndex !== -1 ? values[values.length - 1].value[engBPubIPIndex] : '',
      engBPrivateIPAddr:
        engBPriIPIndex !== -1 ? values[values.length - 1].value[engBPriIPIndex] : '',
      tcpPort: tcpPortIndex !== -1 ? values[values.length - 1].value[tcpPortIndex] : '',
      windowResultsReceived: windowResultsReceived
    };

    return windowResults;
  }

  //eslint-disable-next-line
  getThinClientWindowResults(result, configuration) {
    let windowResults = {};
    const upstreamIdeal = [];
    const upstreamAvg = [];
    const upstreamWindow = [];
    const downstreamIdeal = [];
    const downstreamAvg = [];
    const downstreamWindow = [];
    let windowResultsReceived = 0;
    const windowId = 0;

    const table = result['ietf-lmap-report:report'].result[0].table[0];
    const testTypeIndex = table.column.indexOf('truespeed-type');
    const originatorIndex = table.column.indexOf('originator');
    const idealThruIndex = table.column.indexOf('ideal-thruput');
    const avgThruIndex = table.column.indexOf('avg-thruput');
    const tcpPortIndex = table.column.indexOf('tcp-port');
    //const connectionIndex = table.column.indexOf('connections');
    const rttIndex = table.column.indexOf('rtt-avg');
    const rttBaseIndex = table.column.indexOf('baseline-rtt');
    const httpsRttAvgIndex = table.column.indexOf('https-rtt-avg');
    const engAIpIndex = table.column.indexOf('engine-a-ip');
    const engBPubIPIndex = table.column.indexOf('engine-b-public-ip');
    const engBPriIPIndex = table.column.indexOf('engine-b-private-ip');
    const engBTypeIndex = table.column.indexOf('engine-b-type');

    //Initialize window
    for (let i = 1; i <= configuration.numWindow; i++) {
      upstreamWindow.push('Window ' + i);
      upstreamIdeal.push(0);
      upstreamAvg.push(0);

      downstreamWindow.push('Window ' + i);
      downstreamIdeal.push(0);
      downstreamAvg.push(0);
    }

    //Populate upstream/downstream thruput
    const values = table.row;
    windowResultsReceived = values.length;
    // let isThinClientTest = false;
    for (let i = 0; i < values.length; i++) {
      if (values[i].value[testTypeIndex] === 'thin-engine') {
        const originator = values[i].value[originatorIndex];
        let idealValue = this.getTargetValue(values[i].value[idealThruIndex]);
        let avgValue = 0;
        if (values[i].value[avgThruIndex] !== '') {
          avgValue = parseFloat(values[i].value[avgThruIndex]);
        } else {
          windowResultsReceived--;
        }

        let ideal = upstreamIdeal;
        let avg = upstreamAvg;
        let window = upstreamWindow;

        if (originator === 'engine-a') {
          ideal = downstreamIdeal;
          avg = downstreamAvg;
          window = downstreamWindow;

          idealValue = idealValue * -1;
          avgValue = avgValue * -1;
        }

        window[windowId] = 'Walk 1';
        ideal[windowId] = idealValue;
        avg[windowId] = avgValue;
      }
    }

    windowResults = {
      upstream: {
        window: upstreamWindow,
        ideal: upstreamIdeal,
        avg: upstreamAvg
      },

      downstream: {
        window: downstreamWindow,
        ideal: downstreamIdeal,
        avg: downstreamAvg
      },

      rttBase: parseFloat(values[0].value[rttIndex]).toFixed(2),
      windowResultsReceived: windowResultsReceived,
      httpsRttAvg: parseFloat(values[0].value[httpsRttAvgIndex]).toFixed(2),
      engAIPAddr: engAIpIndex !== -1 ? values[values.length - 1].value[engAIpIndex] : '',
      engBPublicIPAddr:
        engBPubIPIndex !== -1 ? values[values.length - 1].value[engBPubIPIndex] : '',
      engBPrivateIPAddr:
        engBPriIPIndex !== -1 ? values[values.length - 1].value[engBPriIPIndex] : '',
      engBType:
        engBTypeIndex !== -1
          ? values[values.length - 1].value[engBTypeIndex] || 'MA-TO-MA'
          : 'MA-TO-MA',
      tcpPort: tcpPortIndex !== -1 ? values[values.length - 1].value[tcpPortIndex] : ''
    };
    return windowResults;
  }

  //eslint-disable-next-line
  getWindowLabel(windowSizeString, connectionString, saturationWindow, dynamicSaturation) {
    let connection: any = parseInt(connectionString);
    const windowSize = parseInt(windowSizeString);
    const windowValue = dynamicSaturation
      ? Math.round(windowSize / 1024)
      : Math.round((windowSize * connection) / 1024);
    let aggregateWindow: any = '';
    let aggregateWindowString: any = '';

    if (Number(connection) > 1) {
      connection = connection + ' conns.';
    } else {
      connection = connection + ' conn.';
    }

    if (windowValue > 0) {
      if (windowValue >= 1024) {
        aggregateWindow = windowValue / 1024;
        aggregateWindow = aggregateWindow.toFixed(1) + 'MB';
      } else {
        aggregateWindow = windowValue + 'KB';
      }
      aggregateWindowString =
        ' Total Window<br/>' +
        connection +
        (!dynamicSaturation ? ' x ' + Math.round(windowSize / 1024) + 'KB' : '');
    } else {
      aggregateWindowString = 'No saturation applied';
    }

    if (saturationWindow) {
      aggregateWindowString =
        (dynamicSaturation ? 'Dynamic Saturation<br/>' : 'Saturation<br/>') +
        aggregateWindow +
        aggregateWindowString;
    } else {
      aggregateWindowString = aggregateWindow + aggregateWindowString;
    }

    return aggregateWindowString;
  }
  //eslint-disable-next-line
  getSummary(windowResults, configuration) {
    const upstreamSummary = { direction: 'up' };
    const downstreamSummary = { direction: 'down' };
    let upstreamIndex = 0;
    let downstreamIndex = 0;
    let upStreamThresholdVal = 90;
    let downStreamThresholdVal = 90;

    const table = windowResults['ietf-lmap-report:report'].result[0].table[0];
    const testTypeIndex = table.column.indexOf('truespeed-type');
    const originatorIndex = table.column.indexOf('originator');
    const idealThruIndex = table.column.indexOf('ideal-thruput');
    const avgThruIndex = table.column.indexOf('avg-thruput');
    const peakThruIndex = table.column.indexOf('peak-thruput');
    const windowSizeIndex = table.column.indexOf('window-size');
    const connectionIndex = table.column.indexOf('connections');
    const upstreamDiagnosisIndex = table.column.indexOf('engine-b-to-a-diagnosis');
    const downstreamDiagnosisIndex = table.column.indexOf('engine-a-to-b-diagnosis');
    const rateUnderTestIndex = table.column.indexOf('rate-under-test');
    const thruputThresholdIndex = table.column.indexOf('thruput-threshold');
    const dynamicSatWinConnIndex = table.column.indexOf('dynamic-saturation-total-connections');
    const dynamicSatWinSizeIndex = table.column.indexOf('dynamic-saturation-total-window-size');

    let upstreamMaxAvg = 0;
    let upstreamMaxPeak = 0;
    let upstreamBestWindow;
    let upStreamDynamicSatWin = null;
    let downstreamMaxAvg = 0;
    let downstreamMaxPeak = 0;
    let downstreamBestWindow;
    let upstreamRateUnderTest = 0;
    let downstreamRateUnderTest = 0;
    let downStreamDynamicSatWin = null;
    let upstreamAvg = 0;
    let downstreamAvg = 0;

    let numWindow = configuration.numWindow;
    if (configuration.runSaturationWindow === 'true') {
      numWindow += 1;
    }
    let i;
    let avg;
    let originator = null;
    const values = table.row;
    let rateUnderTest;
    if (testTypeIndex !== -1) {
      // thin client Test

      for (let i = 1; i < values.length; i++) {
        avg = parseFloat(values[i].value[avgThruIndex]).toFixed(1);
        originator = values[i].value[originatorIndex];

        if (originator === 'engine-b') {
          if (thruputThresholdIndex !== -1) {
            upStreamThresholdVal = parseInt(values[i].value[thruputThresholdIndex]);
          }
          upstreamMaxAvg = avg;
          upstreamSummary['target'] = this.getTargetValue(
            parseFloat(values[i].value[idealThruIndex]).toFixed(1)
          );
          upstreamSummary['idealThroughput'] = parseFloat(values[i].value[idealThruIndex]).toFixed(
            1
          );
          upstreamBestWindow = '';
        } else {
          if (thruputThresholdIndex !== -1) {
            downStreamThresholdVal = parseInt(values[i].value[thruputThresholdIndex]);
          }
          downstreamMaxAvg = avg;
          downstreamSummary['target'] = this.getTargetValue(
            parseFloat(values[i].value[idealThruIndex]).toFixed(1)
          );
          downstreamSummary['idealThroughput'] = parseFloat(
            values[i].value[idealThruIndex]
          ).toFixed(1);
          downstreamBestWindow = '';
        }
      }
      upstreamSummary['upStreamThresholdVal'] = upStreamThresholdVal;
      upstreamSummary['cir'] = configuration.upstreamCir;
      upstreamSummary['upstreamVal'] = upstreamMaxAvg;
      upstreamSummary['bestAvg'] =
        upstreamMaxAvg > parseInt(upstreamSummary['idealThroughput'])
          ? parseFloat(upstreamSummary['idealThroughput']).toFixed(1)
          : upstreamMaxAvg;

      upstreamSummary['verdict'] =
        (upstreamMaxAvg / parseFloat(upstreamSummary['target'])) * 100 >= upStreamThresholdVal
          ? 'PASS'
          : 'FAIL';

      downstreamSummary['downStreamThresholdVal'] = downStreamThresholdVal;
      downstreamSummary['cir'] = configuration.downstreamCir;
      downstreamSummary['downstreamVal'] = downstreamMaxAvg;
      downstreamSummary['bestAvg'] =
        downstreamMaxAvg > parseInt(downstreamSummary['idealThroughput'])
          ? parseFloat(downstreamSummary['idealThroughput']).toFixed(1)
          : downstreamMaxAvg;

      downstreamSummary['verdict'] =
        (downstreamMaxAvg / parseFloat(downstreamSummary['target'])) * 100 >= downStreamThresholdVal
          ? 'PASS'
          : 'FAIL';
    } else {
      let upStreamWind = 0;
      let downStreamWind = 0;
      let upStreamConn = 0;
      let downStreamConn = 0;
      for (i = 0; i < values.length; i++) {
        avg = parseFloat(values[i].value[avgThruIndex]);
        const peak = parseFloat(values[i].value[peakThruIndex]);
        originator = values[i].value[originatorIndex];
        rateUnderTest = parseFloat(values[i].value[rateUnderTestIndex]);

        if (originator === 'engine-b') {
          if (thruputThresholdIndex !== -1) {
            upStreamThresholdVal = parseInt(values[i].value[thruputThresholdIndex]);
          }
          upstreamAvg = avg;
          if (
            (upstreamIndex < numWindow && upstreamMaxAvg < avg) ||
            configuration.numWindow === 0
          ) {
            upstreamMaxAvg = avg;
            //eslint-disable-next-line
            upstreamRateUnderTest = rateUnderTest;
            upStreamWind = Math.round(
              (parseInt(values[i].value[windowSizeIndex]) *
                parseInt(values[i].value[connectionIndex])) /
                1024
            );
            upStreamConn = parseInt(values[i].value[connectionIndex]);
            upstreamBestWindow = this.getWindowLabel(
              values[i].value[windowSizeIndex],
              values[i].value[connectionIndex],
              false,
              false
            );
          }
          if (
            dynamicSatWinSizeIndex !== -1 &&
            dynamicSatWinConnIndex !== -1 &&
            values[i].value[dynamicSatWinSizeIndex] &&
            values[i].value[dynamicSatWinConnIndex]
          ) {
            upStreamWind = Math.round(
              upStreamWind + parseInt(values[i].value[dynamicSatWinSizeIndex]) / 1024
            );
            upStreamConn = upStreamConn + parseInt(values[i].value[dynamicSatWinConnIndex]);
            upStreamDynamicSatWin = this.getDynamicSaturationWindowLabel(
              values[i].value[dynamicSatWinSizeIndex],
              values[i].value[dynamicSatWinConnIndex]
            );
          }
          if (upstreamMaxPeak < peak) {
            upstreamMaxPeak = peak;
          }

          upstreamIndex++;
        } else {
          if (thruputThresholdIndex !== -1) {
            downStreamThresholdVal = parseInt(values[i].value[thruputThresholdIndex]);
          }
          downstreamAvg = avg;
          if (
            (downstreamIndex < numWindow && downstreamMaxAvg < avg) ||
            configuration.numWindow === 0
          ) {
            downstreamMaxAvg = avg;
            //eslint-disable-next-line
            downstreamRateUnderTest = rateUnderTest;
            downStreamWind = Math.round(
              (parseInt(values[i].value[windowSizeIndex]) *
                parseInt(values[i].value[connectionIndex])) /
                1024
            );
            downStreamConn = parseInt(values[i].value[connectionIndex]);
            downstreamBestWindow = this.getWindowLabel(
              values[i].value[windowSizeIndex],
              values[i].value[connectionIndex],
              false,
              false
            );
          }

          if (
            dynamicSatWinSizeIndex !== -1 &&
            dynamicSatWinConnIndex !== -1 &&
            values[i].value[dynamicSatWinSizeIndex] &&
            values[i].value[dynamicSatWinConnIndex]
          ) {
            downStreamWind = Math.round(
              downStreamWind + parseInt(values[i].value[dynamicSatWinSizeIndex]) / 1024
            );
            downStreamConn = downStreamConn + parseInt(values[i].value[dynamicSatWinConnIndex]);
            downStreamDynamicSatWin = this.getDynamicSaturationWindowLabel(
              values[i].value[dynamicSatWinSizeIndex],
              values[i].value[dynamicSatWinConnIndex]
            );
          }

          if (downstreamMaxPeak < peak) {
            downstreamMaxPeak = peak;
          }

          downstreamIndex++;
        }
      }

      if (configuration.numWindow !== 0) {
        if (values.length && values.length >= configuration.numWindow) {
          upstreamSummary['target'] = this.getTargetValue(
            values[configuration.numWindow - 1].value[idealThruIndex]
          );
          upstreamSummary['idealThroughput'] = parseFloat(
            values[configuration.numWindow - 1].value[idealThruIndex]
          ).toFixed(1);
        } else if (values.length && values.length > 0) {
          const target = this.getTargetValue(values[0].value[idealThruIndex]);
          upstreamSummary['idealThroughput'] = parseFloat(values[0].value[idealThruIndex]).toFixed(
            1
          );
          upstreamSummary['target'] = isNaN(target) ? '--' : target;
        }

        if (configuration.runSaturationWindow === 'true') {
          if (values.length && values.length >= 2) {
            const target = (downstreamSummary['target'] = this.getTargetValue(
              values[values.length - 2].value[idealThruIndex]
            ));
            downstreamSummary['target'] = isNaN(target) ? '--' : target;
            downstreamSummary['idealThroughput'] = parseFloat(
              values[values.length - 2].value[idealThruIndex]
            ).toFixed(1);
          }
        } else {
          if (values.length && values.length >= 1) {
            downstreamSummary['target'] = this.getTargetValue(
              values[values.length - 1].value[idealThruIndex]
            );
            downstreamSummary['idealThroughput'] = parseFloat(
              values[values.length - 1].value[idealThruIndex]
            ).toFixed(1);
          }
        }
      } else {
        if (values.length && values.length > 0) {
          const target = this.getTargetValue(values[0].value[idealThruIndex]);
          upstreamSummary['idealThroughput'] = parseFloat(values[0].value[idealThruIndex]).toFixed(
            1
          );
          upstreamSummary['target'] = isNaN(target) ? '--' : target;
          if (configuration.jmepIpAddress) {
            downstreamSummary['target'] = upstreamSummary['target'];
          }
        }
        if (values.length && values.length > 1) {
          downstreamSummary['target'] = this.getTargetValue(values[1].value[idealThruIndex]);
          downstreamSummary['idealThroughput'] = parseFloat(
            values[1].value[idealThruIndex]
          ).toFixed(1);
        }
      }
      upstreamSummary['upStreamThresholdVal'] = upStreamThresholdVal;
      upstreamSummary['cir'] = configuration.upstreamCir;
      upstreamSummary['bestAvg'] =
        upstreamMaxAvg > upstreamSummary['idealThroughput']
          ? parseFloat(upstreamSummary['idealThroughput']).toFixed(1)
          : upstreamMaxAvg?.toFixed(1);
      upstreamSummary['bestPeak'] =
        upstreamMaxPeak > upstreamSummary['idealThroughput']
          ? parseFloat(upstreamSummary['idealThroughput']).toFixed(1)
          : upstreamMaxPeak.toFixed(1);

      if (upstreamBestWindow) {
        upstreamSummary['bestWindow'] = upstreamBestWindow.replace('<br/>', ': ');
      }
      upstreamSummary['dynamicSatWin'] = upStreamDynamicSatWin;
      upstreamSummary['totalWinString'] = this.getTotalWindowSizeLabel(upStreamWind, upStreamConn);
      upstreamSummary['diagnosis'] = values[values.length - 1].value[upstreamDiagnosisIndex];
      upstreamSummary['diagnosis'] = upstreamSummary['diagnosis']
        ? upstreamSummary['diagnosis']
        : null;
      upstreamSummary['tcpLow'] =
        upstreamSummary['diagnosis'] &&
        upstreamSummary['diagnosis'].indexOf('TCP_EFFICIENCY_LOW') > -1
          ? true
          : false;

      upstreamSummary['verdict'] =
        upstreamSummary['diagnosis']?.indexOf('ALL_OK') > -1 || upstreamSummary['tcpLow']
          ? 'PASS'
          : 'FAIL';

      downstreamSummary['downStreamThresholdVal'] = downStreamThresholdVal;
      downstreamSummary['cir'] = configuration.downstreamCir;
      downstreamSummary['bestAvg'] =
        downstreamMaxAvg > downstreamSummary['idealThroughput']
          ? downstreamSummary['idealThroughput']
          : downstreamMaxAvg?.toFixed(1);
      downstreamSummary['bestPeak'] =
        downstreamMaxPeak > downstreamSummary['idealThroughput']
          ? downstreamSummary['idealThroughput']
          : downstreamMaxPeak.toFixed(1);

      if (downstreamBestWindow) {
        downstreamSummary['bestWindow'] = downstreamBestWindow.replace('<br/>', ': ');
      }

      downstreamSummary['dynamicSatWin'] = downStreamDynamicSatWin;
      downstreamSummary['totalWinString'] = this.getTotalWindowSizeLabel(
        downStreamWind,
        downStreamConn
      );
      downstreamSummary['diagnosis'] = values[values.length - 1].value[downstreamDiagnosisIndex];
      downstreamSummary['diagnosis'] = downstreamSummary['diagnosis']
        ? downstreamSummary['diagnosis']
        : null;
      downstreamSummary['tcpLow'] =
        downstreamSummary['diagnosis'] &&
        downstreamSummary['diagnosis'].indexOf('TCP_EFFICIENCY_LOW') > -1
          ? true
          : false;

      downstreamSummary['verdict'] =
        downstreamSummary['diagnosis']?.indexOf('ALL_OK') > -1 || downstreamSummary['tcpLow']
          ? 'PASS'
          : 'FAIL';
    }

    return { upstreamSummary, downstreamSummary };
  }

  //eslint-disable-next-line
  getTotalWindowSizeLabel(windowValue: any, totalConn: any) {
    let aggregateWindow: any = 0;
    if (totalConn > 1) {
      totalConn = totalConn + ' conns.';
    } else {
      totalConn = totalConn + ' conn.';
    }

    if (windowValue >= 1024) {
      aggregateWindow = windowValue / 1024;
      aggregateWindow = aggregateWindow.toFixed(1) + 'MB';
    } else {
      aggregateWindow = windowValue.toFixed(0) + 'KB';
    }
    const totalWindowString = aggregateWindow + ' Total Window, ' + totalConn;
    return totalWindowString;
  }
  //eslint-disable-next-line
  getDynamicSaturationWindowLabel(windowSizeString: any, connectionString: any) {
    let connection: any = connectionString ? parseInt(connectionString) : 0;
    const windowValue = connectionString ? Math.round(windowSizeString / 1024) : 0;
    let aggregateWindow: any = '';
    let aggregateWindowString = '';

    if (windowValue > 0) {
      if (Number(connection) > 1) {
        connection = connection + ' conns.';
      } else {
        connection = connection + ' conn.';
      }

      if (windowValue >= 1024) {
        aggregateWindow = windowValue / 1024;
        aggregateWindow = aggregateWindow.toFixed(1) + 'MB';
      } else {
        aggregateWindow = windowValue.toFixed(0) + 'KB';
      }
      aggregateWindowString = ' Total Window, ' + connection;
    } else {
      aggregateWindowString = 'No saturation applied';
    }
    return aggregateWindow + aggregateWindowString;
  }
  //eslint-disable-next-line
  getWindowSummary(result, isAgentToJmep) {
    const windowResults = [];

    const table = result['ietf-lmap-report:report'].result[0].table[0];
    const originatorIndex = table.column.indexOf('originator');
    const windowIdIndex = table.column.indexOf('window-id');
    const windowSizeIndex = table.column.indexOf('window-size');
    const connectionIndex = table.column.indexOf('connections');
    const testTypeIndex = table.column.indexOf('truespeed-type');
    const dynamicSatConnectionIndex = table.column.indexOf('dynamic-saturation-total-connections');

    const column = table.column;
    const values = table.row;

    let upstreamIndex = 1;
    let downstreamIndex = 1;
    let windowResult = {};
    let columnIndex = 0;
    let columnName = null;
    let value = null;

    if (testTypeIndex === -1) {
      for (let i = 0; i < values.length; i++) {
        if (values[i].value[windowIdIndex] !== '') {
          windowResult = {};
          if (values[i].value[originatorIndex] === 'engine-b') {
            windowResult['direction'] = 'Upstream';
            windowResult['index'] = upstreamIndex;
            upstreamIndex++;
          } else {
            if (isAgentToJmep) {
              windowResult['direction'] = 'Throughput';
              windowResult['index'] = downstreamIndex;
            } else {
              windowResult['direction'] = 'Downstream';
              windowResult['index'] = downstreamIndex;
            }
            downstreamIndex++;
          }

          for (columnIndex = 0; columnIndex < column.length; columnIndex++) {
            columnName = column[columnIndex];
            value = values[i].value[columnIndex];

            //Some formatting
            if (
              columnName === 'window-size' ||
              (columnName === 'dynamic-saturation-total-window-size' && value)
            ) {
              let connectionsValue = Number(values[i].value[connectionIndex]) || 0;
              value = Number(value) || 0;

              if (columnName === 'dynamic-saturation-total-window-size') {
                connectionsValue += Number(values[i].value[dynamicSatConnectionIndex]) || 0;
                value += Number(values[i].value[windowSizeIndex]) || 0;
                windowResult['dynamicSaturation'] = true;
              }
              let aggregateWindow = value * connectionsValue;
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              //@ts-ignore
              aggregateWindow = this.formatWindowSize(aggregateWindow);
              windowResult['aggregate-window'] = aggregateWindow;

              value = this.formatWindowSize(value);
              windowResult['connections'] = connectionsValue.toString();
              windowResult['window-size'] = value;
            } else if (
              columnName.indexOf('thruput') !== -1 ||
              columnName.indexOf('rate-under-test') !== -1 ||
              columnName.indexOf('buffer-delay') !== -1 ||
              columnName.indexOf('tcp-efficiency') !== -1
            ) {
              value = parseInt((Number(value) * 100).toString()) / 100;
            }

            windowResult[columnName] = value;
          }
          // if (isAgentToJmep) {
          //   windowResult['window-id'] = '0';
          // }
          windowResults.push(windowResult);
        }
      }
    } else {
      for (let k = 1; k < values.length; k++) {
        windowResult = {};
        if (values[k].value[originatorIndex] === 'engine-b') {
          windowResult['direction'] = 'Upstream';
          windowResult['index'] = upstreamIndex;
          windowResult['window-id'] = 0;
          upstreamIndex++;
        } else {
          windowResult['direction'] = 'Downstream';
          windowResult['index'] = downstreamIndex;
          windowResult['window-id'] = 1;
          downstreamIndex++;
        }

        for (columnIndex = 0; columnIndex < column.length; columnIndex++) {
          columnName = column[columnIndex];
          value = values[k].value[columnIndex];

          //Some formatting
          if (
            columnName.indexOf('avg-thruput') !== -1 ||
            columnName.indexOf('ideal-thruput') !== -1
          ) {
            value = parseFloat(value).toFixed(2);
          }

          windowResult[columnName] = value;
        }

        windowResults.push(windowResult);
      }
    }
    return windowResults;
  }
  //eslint-disable-next-line
  getBarChartOption(direction, numWindow, runTime) {
    let opposite = false;
    let height = numWindow * 50;
    const width = 420;
    let fontColor;
    const plotBackgroundColor = 'white';
    if (height < 250) {
      height = 250;
    }

    const chartOption = {
      renderTo: direction + 'BarChart',
      type: 'bar',
      backgroundColor: 'transparent',
      plotBackgroundColor: plotBackgroundColor,
      plotBorderWidth: 1,
      height: height,
      width: width,
      style: {}
    };

    if (runTime) {
      fontColor = 'white';
      chartOption.plotBackgroundColor = '#424242';

      //Sizing a liitle bit different when test running
      const clientWidth = document.documentElement.clientWidth;
      if (width < clientWidth * 0.35) {
        chartOption.width = clientWidth * 0.35;
      }

      if (height < width * 0.14 * numWindow) {
        chartOption.height = width * 0.14 * numWindow;
      }

      // setupBarChartContainer(direction, chartOption.width);
    }

    const yAxisOption = {
      title: {
        text: 'Avg. TCP Throughput (Mbps)',
        align: 'middle',
        style: {
          color: fontColor
        }
      },
      labels: {
        overflow: 'justify',
        style: {
          color: fontColor
        },
        formatter: function () {
          return Math.abs(this.value);
        }
      }
    };

    if (direction === 'downstream') {
      opposite = true;
      yAxisOption['max'] = 0;
    } else {
      yAxisOption['min'] = 0;
    }

    const option = {
      credits: { enabled: false },
      chart: chartOption,
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      xAxis: {
        title: {
          text: null
        },
        labels: {
          enabled: true,
          style: {
            font: '12px Helvetica',
            color: fontColor
          }
        },
        opposite: opposite,
        tickColor: fontColor
      },
      yAxis: yAxisOption,
      tooltip: {
        formatter: function () {
          return (
            this.series.name + ': ' + Highcharts.numberFormat(Math.abs(this.point.y), 1) + ' Mbps'
          );
        }
      },

      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            formatter: function () {
              if (this.y === 0) {
                return '';
              } else {
                return Math.abs(this.y).toFixed(1);
              }
            }
          }
        }
      },
      series: [
        {
          name: 'Target',
          showInLegend: false,
          color: '#C8C8C8'
        },
        {
          name: 'Actual',
          showInLegend: false,
          color: '#27a0ff'
        }
      ]
    };

    return option;
  }
  //eslint-disable-next-line
  formatWindowSize(windowSize) {
    let size = parseInt(windowSize) / 1024;

    if (size >= 1024) {
      size = size / 1024;
      return size.toFixed(1) + 'MB';
    } else {
      return size.toFixed(0) + 'KB';
    }
  }

  //eslint-disable-next-line
  getThinClientResults(result: any, configuration: any) {
    let windowResults = {};
    const upstreamIdeal = [];
    const upstreamAvg = [];
    const upstreamWindow = [];
    const downstreamIdeal = [];
    const downstreamAvg = [];
    const downstreamWindow = [];
    let windowResultsReceived = 0;
    const windowId = 0;

    const table = result['ietf-lmap-report:report'].result[0].table[0];
    const testTypeIndex = table.column.indexOf('truespeed-type');
    const originatorIndex = table.column.indexOf('originator');
    const idealThruIndex = table.column.indexOf('ideal-thruput');
    const avgThruIndex = table.column.indexOf('avg-thruput');
    const tcpPortIndex = table.column.indexOf('tcp-port');
    const rttIndex = table.column.indexOf('rtt-avg');
    const httpsRttAvgIndex = table.column.indexOf('https-rtt-avg');
    const engAIpIndex = table.column.indexOf('engine-a-ip');
    const engBPubIPIndex = table.column.indexOf('engine-b-public-ip');
    const engBPriIPIndex = table.column.indexOf('engine-b-private-ip');
    const engBTypeIndex = table.column.indexOf('engine-b-type');

    //Initialize window
    for (let i = 1; i <= configuration.numWindow; i++) {
      upstreamWindow.push('Window ' + i);
      upstreamIdeal.push(0);
      upstreamAvg.push(0);

      downstreamWindow.push('Window ' + i);
      downstreamIdeal.push(0);
      downstreamAvg.push(0);
    }

    //Populate upstream/downstream thruput
    const values = table.row;
    windowResultsReceived = values.length;

    for (let i = 0; i < values.length; i++) {
      if (values[i].value[testTypeIndex] === 'thin-engine') {
        const originator = values[i].value[originatorIndex];
        let idealValue = this.getTargetValue(values[i].value[idealThruIndex]);
        let avgValue = 0;
        if (values[i].value[avgThruIndex] !== '') {
          avgValue = parseFloat(values[i].value[avgThruIndex]);
        } else {
          windowResultsReceived--;
        }

        let ideal = upstreamIdeal;
        let avg = upstreamAvg;
        let window = upstreamWindow;

        if (originator === 'engine-a') {
          ideal = downstreamIdeal;
          avg = downstreamAvg;
          window = downstreamWindow;

          idealValue = idealValue * -1;
          avgValue = avgValue * -1;
        }

        window[windowId] = '';
        ideal[windowId] = idealValue;
        avg[windowId] = avgValue;
      }
    }

    windowResults = {
      upstream: {
        window: upstreamWindow,
        ideal: upstreamIdeal,
        avg: upstreamAvg
      },

      downstream: {
        window: downstreamWindow,
        ideal: downstreamIdeal,
        avg: downstreamAvg
      },

      rtt: parseFloat(values[0].value[rttIndex]).toFixed(2),
      windowResultsReceived: windowResultsReceived,
      httpsRttAvg: parseFloat(values[0].value[httpsRttAvgIndex]).toFixed(2),
      engAIPAddr: engAIpIndex !== -1 ? values[values.length - 1].value[engAIpIndex] : '',
      engBPublicIPAddr:
        engBPubIPIndex !== -1 ? values[values.length - 1].value[engBPubIPIndex] : '',
      engBPrivateIPAddr:
        engBPriIPIndex !== -1 ? values[values.length - 1].value[engBPriIPIndex] : '',
      engBType:
        engBTypeIndex !== -1
          ? values[values.length - 1].value[engBTypeIndex] || 'MA-TO-MA'
          : 'MA-TO-MA',
      tcpPort: tcpPortIndex !== -1 ? values[values.length - 1].value[tcpPortIndex] : ''
    };

    return windowResults;
  }

  //eslint-disable-next-line
  getLatestReport(response) {
    const reports = response;
    let latestReport = reports[0];
    let latestSequence = 0;
    for (let i = 0; i < reports.length; i++) {
      if (reports[i]['ietf-lmap-report:report'] && reports[i]['ietf-lmap-report:report'].result) {
        const result = reports[i]['ietf-lmap-report:report'].result[0];

        // look for tags sequence and table-type
        if (result.tag && result.tag.length > 0) {
          let sequence = null;
          let tableType = null;
          let foundSeq = false;
          let foundType = false;
          for (let x = 0, len = result.tag.length; x < len; ++x) {
            if (result.tag[x].indexOf('sequence:') >= 0) {
              sequence = parseInt(result.tag[x].split(':')[1]);
              foundSeq = true;
            }
            if (result.tag[x].indexOf('table-type:') >= 0) {
              tableType = result.tag[x];
              foundType = true;
            }

            if (foundSeq && foundType) {
              break;
            }
          }

          if (
            tableType &&
            sequence &&
            tableType.indexOf('final-results') !== -1 &&
            latestSequence < sequence
          ) {
            latestSequence = sequence;
            latestReport = reports[i];
          }
        }
      }
    }
    return latestReport;
  }
}
